import React, { memo } from 'react';

import { useTQConnectConfig } from '../../../hooks/queries/tqConnectQueries';
import { getCurrentBadge } from '../../../shared/tqConnectUtils';
import { createColorShades } from '../../../shared/utils';
import { THEME } from '../../../types/baseTypes';
import { TQBadgeColorType } from '../../../types/tqConnectTypes';
import PointsPill from '../../Profile/screens/Leaderboard/components/PointsPill/PointsPill';
import { TQ_BADGE_COLORS_MAP } from '../constants';

interface Props {
  score: number;
  iconSize?: number | 'sm';
  style?: React.CSSProperties;
}

const TQConnectBadge: React.FC<Props> = ({ score, iconSize = 20, style }) => {
  const { data: tqConnectConfigResult, isLoading: isTQConfigLoading } =
    useTQConnectConfig();
  const tqConnectConfig = tqConnectConfigResult?.tqConnectConfig;
  const currentBadge = getCurrentBadge(tqConnectConfig?.badges || {}, score);
  const badgeColorConfig =
    TQ_BADGE_COLORS_MAP?.[currentBadge?.color as TQBadgeColorType];

  if (isTQConfigLoading || !currentBadge) {
    return null;
  }

  return (
    <PointsPill
      type="tq"
      points={score}
      name={currentBadge.name}
      iconSize={iconSize}
      showTQConnectBadge
      borderColor={badgeColorConfig.COLOR_HIGHLIGHT}
      backgroundColor={
        createColorShades(
          THEME.LIGHT,
          badgeColorConfig.COLOR_HIGHLIGHT,
          badgeColorConfig.COLOR_HIGHLIGHT,
        )[`${badgeColorConfig.COLOR_HIGHLIGHT}_FILL`]
      }
      style={{
        paddingBlock: 0,
        ...style,
      }}
    />
  );
};

export default memo(TQConnectBadge);
